"use strict";

exports.__esModule = true;
var _Breadcrumbs = require("./Breadcrumbs");
Object.keys(_Breadcrumbs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Breadcrumbs[key]) return;
  exports[key] = _Breadcrumbs[key];
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  exports[key] = _types[key];
});